import { render, staticRenderFns } from "./CompanyRedeems.vue?vue&type=template&id=548fa09e&scoped=true"
import script from "./CompanyRedeems.vue?vue&type=script&lang=js"
export * from "./CompanyRedeems.vue?vue&type=script&lang=js"
import style0 from "./CompanyRedeems.vue?vue&type=style&index=0&id=548fa09e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548fa09e",
  null
  
)

export default component.exports